<template>
  <swiper-slide class="swiper7">
    <head-bar :main_title="main_title" :isT="1"></head-bar>
    <div class="contanier">
      <!-- 这是四角盒子的父亲 -->
      <div class="enterContanier">
        <!--  这是箭头-->
        <div class="leftTopArrow">
        </div>
        <div class="leftBottomArrow"></div>
        <div class="rightTopArrow"></div>
        <div class="rightBottomArrow"></div>
        <!-- 这是左上角的盒子 -->
        <div class="leftTopBox">
          <!-- 这是盒子标题 -->
          <div class="title bigTitle"><i>200+</i>　<b>专利软著</b></div>
          <!-- <div id="softwareChart"></div> -->
          <div class="softwareChart">
            <div class="insideCircle">
            全拓科技<br>获得版权局<br>授予
            </div>
            <div class="outCircle">
               
            </div>
            <span class='myFirstSpan'>数据管理体系</span>
            <span class='mySecondSpan'>舆情监控</span>
            <span class='myThirdSpan'>用户特征预测</span>
            <span class='myForthSpan'>数据可视化</span>
            <span class='myFifthSpan'>数据处理</span>

            <div class="outsideCircle animation"></div>


          </div>
        </div>
        <!-- 这是右上角的盒子 -->
        <div class="RightTopBox">
          <div class="title bigTitle"><i>500+</i>　<b>政府合作项目</b></div>

          <div class="rightTopBody">
            <!-- 这是小球 -->
            <div class="round">
              <div class="circle">
                <img src="../assets/6企业实力/右上center.png" alt="" />
              </div>
              <div class="circle_bottom animation"></div>
            </div>
            <!-- 这是四边的气泡框 -->
            <div class="roundCorner">
              <div class="leftTopCorner">数字园区</div>
              <div class="rightTopCorner">数字政府</div>
              <div class="leftBottomCorner">数字教育</div>
              <div class="rightBottomCorner">数字交通</div>
            </div>
          </div>
        </div>
        <!-- 这是左下角的盒子-->
        <div class="leftBottomBox">
      
          <div class="leftBottomBody">
            <div class="smallLeftBox">
              <div class="topSmallBox"></div>
              <div class="centerSmallBox"></div>
              <div class="bottomSmallBox"></div>
            </div>
            <div class="smallRightBox">
              <div class="firstBox">全拓智慧社区管理平台</div>
              <div class="secondBox">全拓智慧新零售平台</div>
              <div class="thirdBox">社区场景金融服务平台</div>
              <div class="forthBox">数字企业智能服务平台</div>
            </div>
          </div>
        </div>
        <!-- 这是右下角的盒子 -->
        <div class="rightBottomBox">
          <div class="title bigTitle">
            <b>技术与安全</b>
          </div>
          <div class="rightBottomBody">
            <div class="circleBox"></div>
            <div class="circleCover">
              <div class="circleCoverLeft">
                <div class="blank"></div>
                <div class="building"></div>
              </div>
              <div class="circleCoverCenter">
                <span class="coverText">全拓科技数字化智能生态机房与专业的信息安全管理人员,承接数据中心业务和数据接入服务。
</span>
              </div>
              <div class="circleCoverRight">
                <div class="blank"></div>
                <div class="certification"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 这是中心 -->
      <div class="datacenter">
        <!-- 这是中间橙色圆形 -->
        <div class="center">
          <div class="text">
            <div class="num">500+</div>
            <div class="gover">政府合作项目</div>
          </div>
        </div>
        <!-- 这是中间两头的文字 -->
        <div class="side">
          <div class="uptext">专业数据中心</div>
          <div class="downtext">数据中台</div>
        </div>
        <!-- 这是中间四边的文字 -->
        <div class="roundtext">
          <div class="leftop">
            <div class="imageicon">
              <img src="../assets/6企业实力/软件著作权icon.png" />
            </div>
            <div class="smallText">软件著作权</div>
          </div>
          <div class="rightop">
            <div class="imageicon">
              <img src="../assets/6企业实力/政府合作项目icon.png" />
            </div>
            <div class="smallText">政府合作项目</div>
          </div>
          <div class="leftdown">
            <div class="imageicon">
              <img src="../assets/6企业实力/软著案例icon.png" />
            </div>
            <div class="smallText">软著案例</div>
          </div>
          <div class="rightdown">
            <div class="imageicon">
              <img src="../assets/6企业实力/技术与安全icon.png" />
            </div>
            <div class="smallText">技术与安全</div>
          </div>
        </div>
      </div>
    </div>
  </swiper-slide>
</template>  

<script>
import headBar from "../components/headBar.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
// require("../util/echarts-all.js")


export default {
  name: "enterpriseStrength",
  components: {
    swiper,
    swiperSlide,
    headBar,
  },
  data() {
    return {
      main_title: require("../assets/title6.png"),
    };
  },
  methods: {
    softwareChart() {
      var chartDom = document.getElementById("softwareChart");
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        calculable: false,
        series: [
          {
            name: "inner",
            type: "pie",
            selectedMode: "single",
            width: "auto",
            height: "auto",
            radius: [0, 50],

            itemStyle: {
              normal: {
                color: "rgba(0,87,217,0.66)",
                label: {
                  position: "center",
                  textStyle: {
                    color: "#fff350",
                    fontSize: 16,
                  },
                },
                labelLine: {
                  show: false,
                },
              },
            },

            data: [
              {
                value: 100,
                name: "\n全拓科技\n获得版权局\n授予\n",
              },
            ],
          },
          {
            name: "outside",
            type: "pie",
            radius: [60, 125],
            startAngle: 125,
            // for funnel

            funnelAlign: "left",
            selectedMode: "single",
            itemStyle: {
              normal: {
                borderWidth:3,
                // color: "rgba(0,154,215,0.66)",
                color: "#0073dc",

                borderRadius: 10,

                borderColor: "rgba(255,255,255,0.4)",

                label: {
                  textStyle: {
                    color: "#fff",
                    fontSize: 14,
                  },
                  position: "inner",
                },
                labelLine: {
                  show: false,
                },
              },
              // borderRadius: ["0", "0", 23, 22]
            },
            emphasis: {
              disabled: true,
            },
            data: [
              {
                value: 500,
                name: "数据管理体系",
              },
              {
                value: 500,
                name: "数据处理",
              },
              {
                value: 500,
                name: "数据可视化",
              },
              {
                value: 500,
                name: "用户特征检测",
              },
              {
                value: 500,
                name: "舆情监控",
              },
            ],
          },
        ],
      };

      option && myChart.setOption(option);
    },
  },
  created() {},
  mounted() {
    this.softwareChart();
  },
};
</script>
<style lang="less" scoped>
@import "../style/enterpriseStrength.less";
</style>